export default __webpack_public_path__ + "static/media/DownloadFormsFiles.ef3f6a2c.png";